import { MDBInput } from 'mdbreact'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import axios from 'axios'

const InventarioConfiguracion = ({ cambiarInventario }) => {
    const [agotado, setAgotado] = useState({ nombre: 'Agotado', rangofin: 0 })
    const [pocasExis, setPocasExis] = useState({ nombre: 'Pocas Existencias', rangoini: 0, rangofin: 0 })
    const [conExist, setconExist] = useState({ nombre: 'En Existencia', rangoini: 0 })

    const baseUrl = process.env.REACT_APP_BASE_URL
    const api = process.env.REACT_APP_API
    const urlConfiguraciones = baseUrl + api + 'configuraciones/'


    useEffect(() => {
        const peticionTraeDatosAll = async () => {
            try {
                const response = await axios(urlConfiguraciones)
                const data = response.data
                const datos = data[16]
                const alertas = JSON.parse(datos.valor)
                setAgotado(alertas[0])
                setPocasExis(alertas[1])
                setconExist(alertas[2])
            } catch (error) {
                console.log(error)
            }
        }

        peticionTraeDatosAll()
    }, [])

    const peticionPut = async () => {
        try {
            let Alert = [agotado, pocasExis, conExist]
            let f = new FormData()
            f.append('nombre', 'ALERTAS_INVENTARIO')
            f.append('valor', JSON.stringify(Alert))
            f.append('METHOD', 'PUT')
            const respuesta = await axios.post(urlConfiguraciones, f)
            cambiarInventario('ver')
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <div>
            <h5>Alertas:</h5>
            <div className="row">

                <div className="col-md-4"> <br></br><p className="estados Rojo">Agotado</p></div>
                <div className="col-md-8"><MDBInput label="Rango Menor a " outline
                    value={agotado.rangofin}
                    onChange={e => setAgotado({ ...agotado, rangofin: e.target.value })} />
                </div>


                <div className="col-md-4"> <br></br><p className="estados Amarillo">Con pocas Existencias</p></div>
                <div className="col-md-4"><MDBInput label="Rango Inicial " outline
                    value={pocasExis.rangoini}
                    onChange={e => setPocasExis({ ...pocasExis, rangoini: e.target.value })} />
                </div>
                <div className="col-md-4"><MDBInput label="Rango Final" outline
                    value={pocasExis.rangofin}
                    onChange={e => setPocasExis({ ...pocasExis, rangofin: e.target.value })} />
                </div>


                <div className="col-md-4"> <br></br><p className="estados Verde">Con Existencias</p></div>
                <div className="col-md-8"><MDBInput label="Rango Mayor a" outline
                    value={conExist.rangoini}
                    onChange={e => setconExist({ ...conExist, rangoini: e.target.value })} />
                </div>
                <div className="col text-center">
                    <button
                        onClick={peticionPut}
                        className="btn boton_estandar"
                    >Actualizar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default InventarioConfiguracion